<!--TeRank:教师本月排行榜 2021/03/17 11:08:06 YuAng-->

<template>
  <ul v-if="ranks && ranks.length > 0" class="its-te-rank">
    <li class="its-rank-th">
      <span class="col1">教师排行</span>
      <span class="col2">
        授课
         <el-tooltip placement="right-start" :offset="-10">
          <div slot="content" style="line-height: 1.5">只统计有效课程，有效课程 = 授课时长 > 10分钟</div>
          <i class="its-icon its-icon-question-circle" style="font-size:12px;margin-left: 0"></i>
        </el-tooltip>
      </span>
      <span class="col3">预习</span>
      <span class="col4">校本贡献</span>
    </li>
    <li v-for="(item,index) in ranks" :key="'rank' + index" :class="'rank' + index">
      <span class="col1"><i>{{index + 1}}.</i>{{item.userName}}</span>
      <span class="col2">{{item.classroomCount}}节</span>
      <span class="col3">{{item.preClassCount}}份</span>
      <span class="col4">{{item.schoolResourceCount}}份</span>
    </li>
  </ul>
  <div-no-data v-else style="height: 376px;margin-top: -30px">
    <p class="empty">暂无排行信息</p>
  </div-no-data>
</template>
<script>
import { teacherHomeApi } from '@/utils/api'
import DivNoData from '../../../components/DivNoData.vue'
export default {
  name: 'TeRank',
  components: { DivNoData },
  props: {
    link: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      ranks: []
    }
  },
  created() {
    // 请求接口
    teacherHomeApi.getRanks().then((resp) => {
      this.ranks = resp.body
      this.$emit('calc-height', this.ranks)
    })
  }
}
</script>

<style scoped>
.its-te-rank {
  margin: 0 20px 30px 20px;
  max-height:  253px;
}

.its-te-rank li {
  height: 38px;
  width: 100%;
  margin-bottom: 4px;
  background: #fbfbfb;
  line-height: 38px;
  border-radius: 4px;
}

.its-te-rank li span {
  display: inline-block;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 8px;
  font-size: 12px;
}

.its-rank-th {
  background: #f9fcff !important;
}

.its-rank-th span {
  color: #95a8bc;
}

.its-te-rank li span.col1 {
  width: 35%;
  text-align: left;
}

.its-te-rank li .col1 i {
  font-style: normal;
  float: left;
  width: 14px;
  height: 20px;
  background-size: 100%;
  font-weight: 500;
}

.its-te-rank li.rank0 .col1 i {
  background-image: url("../../../../assets/images/teacher-rank1.png");
  color: transparent;
  margin: 8px 4px 0 0;
}

.its-te-rank li.rank1 .col1 i {
  background-image: url("../../../../assets/images/teacher-rank2.png");
  color: transparent;
  margin: 8px 4px 0 0;
}

.its-te-rank li.rank2 .col1 i {
  background-image: url("../../../../assets/images/teacher-rank3.png");
  color: transparent;
  margin: 8px 4px 0 0;
}

.its-te-rank li span.col2,
.its-te-rank li span.col3 {
  width: 22.5%;
}

.its-te-rank li span.col4 {
  width: 20%;
}
</style>